import LeaveEvent from '@/components/requests/leave/events/LeaveEvent'

export default class CommentRestoredEvent extends LeaveEvent {
  asText(viewer) {
    return `**${this.getActorName(viewer)}** restored a comment`
  }
}
